// extracted by mini-css-extract-plugin
export default {"main":"Detail_main__wEA3g","left":"Detail_left__UFMIa"};